import React from 'react';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { PageSubmitButton } from 'Views/Page/Components/PageSubmitButton/PageSubmitButton';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  SecondaryActionButtonRel,
} from 'Packages/FacetCore/Experimental/RelationshipComponents/SecondaryActionButtonRel';
import {
  FDContentContainer, FDStack, FDPaper,
} from '@facet-wealth/design';
import { ImageRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ImageRel';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { dataAttrs } from 'Helpers/Testing';
import { WizardLayout, LayoutPaper, LayoutPaperActions } from '../Components';

const useStyles = buildUseStyles('BasicInformationStep', () => ({
  root: {
    '& img': {
      width: 'auto !important',
      borderRadius: '0px !important',
    },
    '& [data-element-semantic="info-box"]': {
      flex: 1,
      flexBasis: '200px',
    },
  },
}));

export const Layout = () => {
  const { pageContentResource } = usePageContentContext();
  const classes = useStyles();

  const isSubmitDisabled = pageContentResource.attr('addressInformationMissing') === 'true';

  return (
    <WizardLayout>
      <FDContentContainer maxWidth={'sm'}>
        <div className={classes.root}>
          <LayoutPaper>
            <FDStack direction={'row'} spacing={2} padding={2} wrap>
              <FDPaper color={'subtle'} padding={2} {...dataAttrs('info-box')}>
                <FDStack direction={'column'} alignItems={'center'} spacing={2}>
                  {pageContentResource.withRelationship(fr.relationships.householdImage.name, (rel) => {
                    return (
                      <ImageRel width={'80px'} relationship={rel} />
                    );
                  }, () => null)}
                  <div style={{ textAlign: 'center' }}>
                    <MetaControlField attr={'householdInformation'} CustomProps={{ align: 'center' }} />
                  </div>
                </FDStack>
              </FDPaper>
              <FDPaper color={'subtle'} padding={2} {...dataAttrs('info-box')}>
                <FDStack direction={'column'} alignItems={'center'} spacing={2}>
                  {pageContentResource.withRelationship(fr.relationships.addressImage.name, (rel) => {
                    return (
                      <ImageRel width={'80px'} relationship={rel} />
                    );
                  }, () => null)}
                  <MetaControlField attr={'addressInformationMissing'} />
                  <div style={{ textAlign: 'center' }}>
                    <MetaControlField attr={'addressInformation'} />
                  </div>
                </FDStack>
              </FDPaper>
            </FDStack>
            <LayoutPaperActions>
              {pageContentResource.withRelationship(fr.relationships.profilePage.name, (rel) => {
                return (
                  <SecondaryActionButtonRel relationship={rel} disabled={isSubmitDisabled} {...dataAttrs('edit-btn')} />
                );
              }, () => null)}
              <PageSubmitButton resource={pageContentResource} />
            </LayoutPaperActions>
          </LayoutPaper>
        </div>
      </FDContentContainer>
    </WizardLayout>
  );
};
